
import { defineComponent, SetupContext, computed } from "vue";
import store from "@/store";
import NativeClient from "@/client/native-client";
import {
  FavoriteFolders, FavoriteRecipeClips, FolderInfo, FOLDER_ID_ALL
} from "@/types/recipes";
import MyListFolderList from "./MyListFolderList.vue";
export default defineComponent({
  name: "MyListFolderDialog",
  components: { MyListFolderList },
  props: {
    /** ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    const folderList = computed(() => {
      const result: FavoriteFolders = store.getters["recipes/getFolderList"];
      const recent: FavoriteRecipeClips = store.getters["recipes/getRecentMyList"];
      if (!(result && result.folders && recent && recent.clips)) {
        NativeClient.sendDebugLog("MyListFolderDialog folderList null");
        return null;
      }
      let imageUrl = "";
      if (recent.clips.length != 0) {
        imageUrl = recent.clips[0].imageUrl;
      }
      const folderList: FolderInfo[] = [];
      const element = new FolderInfo();
      element.id = FOLDER_ID_ALL;
      element.name = "すべて";
      element.image = imageUrl;
      element.numberOfItems = 0;
      folderList.push(element);
      for (const folderElement of result.folders) {
        const element = new FolderInfo();
        element.id = folderElement.favoriteFolderId;
        element.name = folderElement.name;
        element.image = folderElement.imageUrl;
        element.numberOfItems = folderElement.clipCount;
        folderList.push(element);
      }
      NativeClient.sendDebugLog("MyListFolderDialog folderList " + JSON.stringify(folderList));
      return folderList;
    });
    const computeShowDialog = computed(async () => {
      if (!props.showDialog) {
        store.dispatch("recipes/updateFolderList", null);
      }
    });
    const onClickClose = () => {
      context.emit("close-click");
    };
    const selectCheck = (folderId: number, checked: boolean) => {
      context.emit("select-check", folderId, checked);
    };
    const onClickPositive = () => {
      context.emit("positive-click");
    };
    return {
      onClickClose,
      computeShowDialog,
      folderList,
      selectCheck,
      onClickPositive
    };
  }
});
